// import { XzxXxx } from '@xzx-design/components/xxx'
// ----solt----

import { Button, ButtonGroup } from '@xzx-design/components/button'
import { Lottie } from '@xzx-design/components/lottie'
import { Text } from '@xzx-design/components/text'
import { Panel } from '@xzx-design/components/panel'
import { Icon } from '@xzx-design/components/icon'
import { Seckbd } from '@xzx-design/components/seckbd'
import { Step, Steps } from '@xzx-design/components/steps'
import { Dialog } from '@xzx-design/components/dialog'
import { Overlay } from '@xzx-design/components/overlay'
import { Divider } from '@xzx-design/components/divider'
import { Cell, CellGroup } from '@xzx-design/components/cell'
import { Field } from '@xzx-design/components/field'
import { Popup } from '@xzx-design/components/popup'
import { Loading } from '@xzx-design/components/loading'
import { Form } from '@xzx-design/components/form'
import { Tabs } from '@xzx-design/components/tabs'
import { Tab } from '@xzx-design/components/tab'
import { Sticky } from '@xzx-design/components/sticky'
import { Search } from '@xzx-design/components/search'
import { Radio, RadioGroup } from '@xzx-design/components/radio'
import { Checkbox, CheckboxGroup } from '@xzx-design/components/checkbox'
import { Swipe, SwipeItem } from '@xzx-design/components/swipe'
import { IndexAnchor, Indexes } from '@xzx-design/components/indexes'
import { Sidebar, SidebarItem } from '@xzx-design/components/sidebar'
import { NavBar } from '@xzx-design/components/nav-bar'
import {
  Skeleton,
  SkeletonAvatar,
  SkeletonImage,
  SkeletonParagraph,
  SkeletonTitle,
} from '@xzx-design/components/skeleton'
import { Select, SelectGroup } from '@xzx-design/components/select'
import { Cascader } from '@xzx-design/components/cascader'
import { Stepper } from '@xzx-design/components/stepper'
import { Image } from '@xzx-design/components/image'
import { ImagePreview } from '@xzx-design/components/image-preview'
import { Upload } from '@xzx-design/components/upload'
import { Badge } from '@xzx-design/components/badge'
import { Calendar } from '@xzx-design/components/calendar'
import { Progress } from '@xzx-design/components/progress'
import { Circle } from '@xzx-design/components/circle'
import { List } from '@xzx-design/components/list'
import { PullRefresh } from '@xzx-design/components/pull-refresh'
import { Popover } from '@xzx-design/components/popover'
import { Tag } from '@xzx-design/components/tag'
import { Empty } from '@xzx-design/components/empty'
import { Switch } from '@xzx-design/components/switch'
import { Grid, GridItem } from '@xzx-design/components/grid'

// 业务组件
import { BaseList } from '@xzx-design/components/base-list'

import type { Plugin } from 'vue'

export default [
  Text,
  Button,
  ButtonGroup,
  Lottie,
  Panel,
  Icon,
  Steps,
  Step,
  Dialog,
  Overlay,
  Divider,
  Cell,
  CellGroup,
  Field,
  Popup,
  Loading,
  Form,
  Tabs,
  Tab,
  Sticky,
  Search,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Swipe,
  SwipeItem,
  Indexes,
  IndexAnchor,
  Sidebar,
  SidebarItem,
  NavBar,
  Skeleton,
  SkeletonAvatar,
  SkeletonImage,
  SkeletonParagraph,
  SkeletonTitle,
  Select,
  SelectGroup,
  Cascader,
  Stepper,
  Image,
  ImagePreview,
  Upload,
  Badge,
  Calendar,
  Progress,
  Circle,
  List,
  PullRefresh,
  Popover,
  Tag,
  Empty,
  Switch,
  Grid,
  GridItem,
  // 业务组件
  Seckbd,
  BaseList,
] as Plugin[]
